export default "__VITE_ASSET__BBt1IlWd__"